<script setup lang="ts">
import { ref, watch } from 'vue';
import api from '@/api';
import { DgrDialog } from '@stockmarkteam/donguri-ui';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';

type Props = {
  groupTagId: number;
  groupTagName: string;
};

// このコンポーネントはDgrDialogをラップしているだけなので、openの値をこのコンポーネント内で変更しない。
const open = defineModel<boolean>('open', { default: false });

const props = defineProps<Props>();

const emit = defineEmits<{
  close: [];
  submit: [
    {
      groupTagId: number;
    },
  ];
}>();

watch(
  () => open.value,
  () => {
    if (!open.value) {
      emit('close');
    }
  },
);

const { createSnackbar } = useSnackbar();
const isLoading = ref(false);

const submit = async () => {
  isLoading.value = true;
  try {
    await api.deleteGroupTag(props.groupTagId);
    createSnackbar({
      message: 'グループタグを削除しました',
      type: 'success',
    });
    emit('submit', { groupTagId: props.groupTagId });
  } catch (e) {
    createSnackbar({
      message: 'グループタグの削除に失敗しました',
      type: 'error',
    });
    throw e;
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <DgrDialog v-model:open="open" title="グループタグを削除">
    <template #description>
      <div class="modal-content">
        <p class="c-text-regular--m">{{ groupTagName }}を削除します。</p>
      </div>
    </template>

    <template #submit>
      <button
        type="button"
        class="c-btn c-btn--auto c-btn--negative"
        @click="submit"
        :disabled="isLoading"
        :class="{ disabled: isLoading }"
      >
        削除
      </button>
    </template>
  </DgrDialog>
</template>
